module.exports = __webpack_public_path__ + "static/img/301.4757430b.png";